function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M26.327,50.532a11.253,11.253,0,0,1-3.11.852A5.367,5.367,0,0,0,25.591,48.4a10.786,10.786,0,0,1-3.422,1.306A5.4,5.4,0,0,0,12.833,53.4a5.557,5.557,0,0,0,.125,1.231A15.277,15.277,0,0,1,1.833,48.984,5.4,5.4,0,0,0,3.492,56.2a5.33,5.33,0,0,1-2.439-.665v.059a5.422,5.422,0,0,0,4.324,5.3,5.387,5.387,0,0,1-1.415.178,4.772,4.772,0,0,1-1.022-.092,5.449,5.449,0,0,0,5.043,3.76,10.845,10.845,0,0,1-6.692,2.3A10.108,10.108,0,0,1,0,66.969a15.2,15.2,0,0,0,8.28,2.422A15.256,15.256,0,0,0,23.642,54.032c0-.239-.008-.469-.02-.7A10.767,10.767,0,0,0,26.327,50.532Z",
  transform: "translate(0 -48)",
  fill: "#a7adaf"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.327,
    height: 21.391,
    viewBox: "0 0 26.327 21.391",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.3acc28df.svg";
export { ForwardRef as ReactComponent };